import apis from "../common/apis";
import IPaymentMethod from "../models/paymentMethodModel";
import { HTTP_METHOD_GET, HTTP_METHOD_POST } from "../utils/constant";
import { callApi } from "./fetchTools";

export const getPaymentMethods = () => {
  return callApi<IPaymentMethod[]>(HTTP_METHOD_GET, apis.payment_methods, null);
};

export default {
  getPaymentMethods,
  signAndEncryptPaymentRequest: (params: any) => {
    return callApi(HTTP_METHOD_POST, apis.sc_payment_sign_encrypt, params);
  },
  payooPayment: (params: any) => {
    return callApi(HTTP_METHOD_POST, apis.payoo_payment, params);
  },
  payooPaymentRetry: (params: any) => {
    return callApi(HTTP_METHOD_POST, apis.payoo_retry_payment, params);
  },
  payooVerifyTransaction: (data: any) => {
    return callApi(HTTP_METHOD_POST, apis.payoo_verify_transaction, data);
  },
};
